module.exports = __webpack_public_path__ + "img/材料力学8_3_2.c4d26ad0.jpg";